import { t } from '@lingui/core/macro';
import { isPossiblePhoneNumber } from '@pocketlaw/tetris';
import { mixed, string } from 'yup';
import { EsigningProviderAuthenticationModeSlug, EsigningRecipientType } from 'shared/domains/apollo/generated/types';
/**
 * Required String
 */
export const getRequiredString = () => string().required(t({ comment: 'Esigning party form - Required field error message', message: 'This is a required field' }));
export const getEmailField = (options) => {
    const invalidEmailErrorMessage = t({
        comment: 'Esigning party form - Invalid email error message',
        message: 'This email is invalid',
    });
    const duplicateEmailErrorMessage = t({
        comment: 'Error message for the user when they add or edit an eSigning party with the same email as another default signing party',
        message: 'You have already added another party with this email',
    });
    return getRequiredString()
        .email(invalidEmailErrorMessage)
        .test('duplicate-email', duplicateEmailErrorMessage, (email = '') => {
        const { allRecipients, isEdit, initialEmail, allowDuplicateEmails = false } = options;
        if (allowDuplicateEmails) {
            return true;
        }
        // If we are editing a recipient and the email has not changed, the email isn't a duplicate
        if (isEdit && email === initialEmail) {
            return true;
        }
        // If the recipient is new and the email is already in the list of recipients, it's a duplicate
        return !allRecipients.some((recipient) => recipient.email === email);
    });
};
/**
 * Mobile Field
 */
export const getMobileField = () => {
    const invalidMobileErrorMessage = t({
        comment: 'Esigning party form - Invalid phone number error message',
        message: 'This phone number is invalid',
    });
    return string().when('authenticationMode', {
        is: EsigningProviderAuthenticationModeSlug.SmsOtp,
        then: getRequiredString().test('valid-phone-number', invalidMobileErrorMessage, (mobile = '') => isPossiblePhoneNumber(mobile)),
        otherwise: string(),
    });
};
/**
 * Authentication Mode Field
 */
export const getAuthenticationModeField = (supportedModes) => {
    const unsupportedAuthenticationModeErrorMessage = t({
        comment: 'Esigning party form - Unsupported authentication mode error message',
        message: 'This authentication mode is not supported for this provider',
    });
    return mixed()
        .when('type', {
        is: (type) => type === EsigningRecipientType.Signatory && supportedModes.length > 0,
        then: getRequiredString(),
        otherwise: string(),
    })
        .test('unsupported-authentication-mode', unsupportedAuthenticationModeErrorMessage, (mode) => !mode || supportedModes.includes(mode));
};
